<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Horarios</span>
            <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( horarios  , 'HORARIOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

            
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="6" lg="5">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="horarios"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  dense
                >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->

                  <template v-slot:item.lunes="{ item }">
                    <v-icon small v-text="item.lunes ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.martes="{ item }">
                    <v-icon small v-text="item.martes ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.miercoles="{ item }">
                    <v-icon small v-text="item.miercoles ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.jueves="{ item }">
                    <v-icon small v-text="item.jueves ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.viernes="{ item }">
                    <v-icon small v-text="item.viernes ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.sabado="{ item }">
                    <v-icon small v-text="item.sabado ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.domingo="{ item }">
                    <v-icon small v-text="item.domingo ? 'mdi-check' : 'mdi-close'" color="primary"></v-icon>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="primary" 
                      x-small
                      icon
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn 
                      color="error" 
                      x-small
                      icon
                      @click="deleteItem(item)"
                      class="mr-2"
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.idhorarios }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.horario"
                label="* Horario"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.horainicio"
                label="* Fecha inicio"
                filled
                hide-details
                dense
                type="time"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.horafinal"
                label="* Fecha final"
                filled
                hide-details
                dense
                type="time"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.lunes"
                label="L"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.martes"
                label="M"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.miercoles"
                label="X"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.jueves"
                label="J"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.viernes"
                label="V"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.sabado"
                label="S"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="editedItem.domingo"
                label="D"
                color="primary"
                :value="1"
                hide-details
              ></v-checkbox>
            </v-col>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idhorarios:0,
        horario:'',
        horainicio:null,
        horafinal:null,
        lunes:null,
        martes:null,
        miercoles:null,
        jueves:null,
        viernes:null,
        sabado:null,
        domingo:null,
        deleted:0,
        fecha_creacion:null,
      },

      defaultItem: {
        idhorarios:0,
        horario:'',
        horainicio:null,
        horafinal:null,
        lunes:null,
        martes:null,
        miercoles:null,
        jueves:null,
        viernes:null,
        sabado:null,
        domingo:null,
        deleted:0,
        fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      horarios: [],
      headers: [
        { text: 'ID'         , value: 'idhorarios'  },
        { text: 'Horario'    , value: 'horario'     },
        { text: 'Inicia'     , value: 'horainicio'  },
        { text: 'Termina'    , value: 'horafinal'   },
        { text: 'Lunes'      , value: 'lunes'       },
        { text: 'Martes'     , value: 'martes'      },
        { text: 'Miercoles'  , value: 'miercoles'   },
        { text: 'Jueves'     , value: 'jueves'      },
        { text: 'Viernes'    , value: 'viernes'     },
        { text: 'Sabado'     , value: 'sabado'      },
        { text: 'Domingo'    , value: 'domingo'     },
        { text: 'Fecha'      , value: 'fecha_creacion'   },
        { text: 'Actions'    , value: 'actions', sortable: false },
      ],
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar horario' : 'Editar horario'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
          this.horarios = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.horarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.horarios.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('horarios.update/' + this.editedItem.idhorarios, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if(this.editedItem.horario == ''){
          this.validarErrorDirecto('Favor de llenar todos los campos')
        }
        // Cargamos al usuario que hizo el cambio
        this.editedItem['id_usuario'] = this.getdatosUsuario.iderp
        this.cargar = true

        if (this.editedIndex > -1) {
          // Lo mandapos por el EP
          this.$http.put('horarios.update/' + this.editedItem.idhorarios, this.editedItem).then(response=>{
            this.validarSuccess( response.data.message )
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })

        } else {
          // Lo mandapos por el EP
          this.$http.post('horarios.add', this.editedItem).then(response=>{
            this.initialize()
            this.cargar = false
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
        this.close()
      },
    },
  }
</script>


